<template>
    <footer id="footer" class="footer">
        <div class="containerWrapper">
            <div class="container">

            </div>
        </div>
    </footer>
</template>

<script>
    import {mapState, mapActions} from 'vuex'

    export default {
        computed: {},

    }
</script>
